export const COMMON_FEATURE_KEY = 'common';
export const MAX_PAX_AMOUNT = 9;
export const MIN_LEAD_PAX_AMOUNT = 1;
export const BOUNDS_FEATURE_KEY = 'bounds';
export const INSTANT_SEARCH_FEATURE_KEY = 'instantSearch';
export const INSTANT_SEARCH_CACHE_EXPIRY = 1000 * 60 * 15; // 15 minutes
